import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { PlanUserInfo } from '../plan-user-info.model';

export enum PlanUserInfoActionTypes {
  LoadPlanUserInfos = '[PlanUserInfo] Load PlanUserInfos',
  AddPlanUserInfo = '[PlanUserInfo] Add PlanUserInfo',
  UpsertPlanUserInfo = '[PlanUserInfo] Upsert PlanUserInfo',
  AddPlanUserInfos = '[PlanUserInfo] Add PlanUserInfos',
  UpsertPlanUserInfos = '[PlanUserInfo] Upsert PlanUserInfos',
  UpdatePlanUserInfo = '[PlanUserInfo] Update PlanUserInfo',
  UpdatePlanUserInfos = '[PlanUserInfo] Update PlanUserInfos',
  DeletePlanUserInfo = '[PlanUserInfo] Delete PlanUserInfo',
  DeletePlanUserInfos = '[PlanUserInfo] Delete PlanUserInfos',
  ClearPlanUserInfos = '[PlanUserInfo] Clear PlanUserInfos',
  GetPlanUserInfos = '[PlanSetting] Get PlanUserInfos',
  GetPlanUserInfosFail = '[PlanSetting] Get PlanUserInfos Fail',
}

export class LoadPlanUserInfos implements Action {
  readonly type = PlanUserInfoActionTypes.LoadPlanUserInfos;

  constructor(public payload: { planUserInfos: PlanUserInfo[] }) {}
}

export class AddPlanUserInfo implements Action {
  readonly type = PlanUserInfoActionTypes.AddPlanUserInfo;

  constructor(public payload: { planUserInfo: PlanUserInfo }) {}
}

export class UpsertPlanUserInfo implements Action {
  readonly type = PlanUserInfoActionTypes.UpsertPlanUserInfo;

  constructor(public payload: { planUserInfo: PlanUserInfo }) {}
}

export class AddPlanUserInfos implements Action {
  readonly type = PlanUserInfoActionTypes.AddPlanUserInfos;

  constructor(public payload: { planUserInfos: PlanUserInfo[] }) {}
}

export class UpsertPlanUserInfos implements Action {
  readonly type = PlanUserInfoActionTypes.UpsertPlanUserInfos;

  constructor(public payload: { planUserInfos: PlanUserInfo[] }) {}
}

export class UpdatePlanUserInfo implements Action {
  readonly type = PlanUserInfoActionTypes.UpdatePlanUserInfo;

  constructor(public payload: { planUserInfo: Update<PlanUserInfo> }) {}
}

export class UpdatePlanUserInfos implements Action {
  readonly type = PlanUserInfoActionTypes.UpdatePlanUserInfos;

  constructor(public payload: { planUserInfos: Update<PlanUserInfo>[] }) {}
}

export class DeletePlanUserInfo implements Action {
  readonly type = PlanUserInfoActionTypes.DeletePlanUserInfo;

  constructor(public payload: { id: string }) {}
}

export class DeletePlanUserInfos implements Action {
  readonly type = PlanUserInfoActionTypes.DeletePlanUserInfos;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearPlanUserInfos implements Action {
  readonly type = PlanUserInfoActionTypes.ClearPlanUserInfos;
}

export class GetPlanUserInfos implements Action {
  readonly type = PlanUserInfoActionTypes.GetPlanUserInfos;
  constructor(public payload: number) {}
}

export class GetPlanUserInfosFail implements Action {
  readonly type = PlanUserInfoActionTypes.GetPlanUserInfosFail;
}

export type PlanUserInfoActions =
 LoadPlanUserInfos
 | AddPlanUserInfo
 | UpsertPlanUserInfo
 | AddPlanUserInfos
 | UpsertPlanUserInfos
 | UpdatePlanUserInfo
 | UpdatePlanUserInfos
 | DeletePlanUserInfo
 | DeletePlanUserInfos
 | ClearPlanUserInfos
 | GetPlanUserInfos
 | GetPlanUserInfosFail;
